import React from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputWithLabel from '_components/FormFields/InputWithLabel';
import SelectWithLabel from '_components/FormFields/SelectWithLabel';
import LocationInputForm from '../../Common/LocationInputForm'
import { GoodsRow } from '../../Common/GoodsRow'
import Divider from '@mui/material/Divider';
import SuiTypography from "_softUI/components/SuiTypography";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SuiButton from "_softUI/components/SuiButton";
import { BillingInput } from './BillingInput'
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import BeenhereRoundedIcon from '@mui/icons-material/BeenhereRounded';
import EuroIcon from '@mui/icons-material/Euro';
import Tracking from '../../ShipmentDisplayModal/Tracking';
import { Loading } from '../../Shared'


export function BookingsInput({
    state,
    tabValue,
    handleSetTabValue,
    carrierOptions,
    countryOptions,
    purchasePrice,
    goodsState,
    handleBasicInfoChange,
    handleGoodsRowChange,
    handleLocationChange,
    addGoodsLine,
    removeGoodsLine,
    saveBillingDetails,
    addPricingDetail,
    addAdditionalService,
    handleDeleteAdditionalService,
    handleDeletePricingDetail,
    handleCopyContentClick,
    handleBookingUpdate,
    handleClose
}) {


    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                open={state.modalOpen}
                maxWidth='xl'
                onClose={handleClose}
                aria-labelledby="max-width-dialog-title"
            >
                {state.modalLoading && <Loading text="Loading" size="h5"></Loading>}
                {!state.modalLoading &&
                    <>
                        <DialogTitle>ID {state.selectedShipment.id}</DialogTitle>
                        <DialogContent sx={{ height: '900px', overflow: 'auto', paddingRight: '2rem', paddingLeft: '2rem' }}>
                            <Divider sx={{ m: 0, width: '100%' }} />
                            <Grid container justifyContent="flex-end" sx={{ backgroundColor: '#fff' }}>
                                <Grid item xs={12}>
                                    <Tabs
                                        orientation='horizontal'
                                        value={tabValue}
                                        onChange={handleSetTabValue}
                                        sx={{ background: "transparent" }}
                                    >
                                        <Tab label="Booking" icon={<BeenhereRoundedIcon sx={{ color: "#A7936A" }} />} value={0} />
                                        <Tab label="Track & trace" icon={<PlaceRoundedIcon sx={{ color: "#A7936A" }} />} value={1} />
                                        <Tab label="Billing" icon={<EuroIcon sx={{ color: "#A7936A" }} />} value={2} />
                                    </Tabs>
                                </Grid>
                            </Grid>
                            <Divider sx={{ m: 0 }} />
                            {tabValue === 0 && (
                                <>
                                    <Grid item container xs={12} spacing={2} mt={2}>
                                        <Grid item container xs={2}>
                                            <SuiTypography variant="h6" color="secondary" fontWeight="bold" textAlign="left" >
                                                Details
                                            </SuiTypography>
                                        </Grid>
                                        <Grid container item xs={9.7} spacing={2}>
                                            <Grid item container xs={12} spacing={1}>
                                                <Grid item xs={4}>
                                                    <SelectWithLabel
                                                        label="Carrier"
                                                        name="carrier"
                                                        onChange={e => handleBasicInfoChange({ target: { name: 'carrier', value: { value: e.value, label: e.label } } })}
                                                        fullWidth
                                                        value={state.selectedShipment.carrier}
                                                        type="date"
                                                        mandatory={true}
                                                        options={carrierOptions}
                                                    />
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <InputWithLabel
                                                        label="Tracking Number"
                                                        name="trackingNumber"
                                                        onChange={e => handleBasicInfoChange(e, "trackingNumber", 35)}
                                                        fullWidth
                                                        value={state.selectedShipment.trackingNumber}
                                                        adornment="#"
                                                        adornmentPosition="end"
                                                        placeholder="carrier tracking number"
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <InputWithLabel
                                                        label="Pickup reference"
                                                        name="pickupReference"
                                                        onChange={e => handleBasicInfoChange(e, "pickupReference", 35)}
                                                        fullWidth
                                                        value={state.selectedShipment.pickupReference}
                                                        adornment="#"
                                                        adornmentPosition="end"
                                                        placeholder="carrier pickup reference"
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item container xs={12} spacing={1}>
                                                <Grid item xs={4}>
                                                    <InputWithLabel
                                                        label="Goods ready for pickup"
                                                        name="pickupStart"
                                                        onChange={e => handleBasicInfoChange(e)}
                                                        fullWidth
                                                        value={state.selectedShipment.pickupStart}
                                                        type="date"
                                                        mandatory={true}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <InputWithLabel
                                                        label="Sender reference"
                                                        name="senderReference"
                                                        onChange={e => handleBasicInfoChange(e, "Sender reference", 35)}
                                                        fullWidth
                                                        value={state.selectedShipment.senderReference}
                                                        adornment="#"
                                                        adornmentPosition="end"
                                                        placeholder="reference"
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <InputWithLabel
                                                        label="Receiver reference"
                                                        name="receiverReference"
                                                        onChange={e => handleBasicInfoChange(e, "Receiver reference", 35)}
                                                        fullWidth
                                                        value={state.selectedShipment.receiverReference}
                                                        adornment="#"
                                                        adornmentPosition="end"
                                                        placeholder="reference"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        display="flex"
                                        alignItems="center"
                                        position="relative"
                                        xs={12}
                                        container
                                        item
                                        mb={2}
                                        sx={{
                                            background: '#fff',
                                            width: '100%',
                                        }}
                                    >
                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item container xs={2}>
                                                <SuiTypography variant="h6" color="secondary" fontWeight="bold" textAlign="left">
                                                    Pickup
                                                </SuiTypography>
                                            </Grid>
                                            <Grid container item xs={9.7} spacing={2}>
                                                <LocationInputForm
                                                    title="Pickup"
                                                    index={0}
                                                    handleInputChange={e => handleLocationChange(e, 0)}
                                                    location={state.selectedShipment.locations[0]}
                                                    countryOptions={countryOptions}
                                                    instant={false}
                                                    admin={true}
                                                    handleLocationChangeWithMaxLenght={e => handleLocationChange(e, 0)}
                                                />
                                            </Grid>
                                            <Grid container item xs={0.3}>
                                                <ContentCopyIcon color='secondary' sx={{ cursor: 'pointer' }} onClick={() => handleCopyContentClick(0)} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        display="flex"
                                        alignItems="center"
                                        position="relative"
                                        xs={12}
                                        container
                                        item
                                        mb={2}
                                        sx={{
                                            background: '#fff',
                                            width: '100%',
                                        }}
                                    >
                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item container xs={2}>
                                                <SuiTypography variant="h6" color="secondary" fontWeight="bold" textAlign="left">
                                                    Delivery
                                                </SuiTypography>
                                            </Grid>
                                            <Grid container item xs={9.7} spacing={2}>
                                                <LocationInputForm
                                                    title="Delivery"
                                                    index={1}
                                                    handleInputChange={e => handleLocationChange(e, 1)}
                                                    location={state.selectedShipment.locations[1]}
                                                    countryOptions={countryOptions}
                                                    instant={false}
                                                    admin={true}
                                                    handleLocationChangeWithMaxLenght={e => handleLocationChange(e, 1)}
                                                />
                                            </Grid>
                                            <Grid container item xs={0.3}>
                                                <ContentCopyIcon color='secondary' sx={{ cursor: 'pointer' }} onClick={() => handleCopyContentClick(1)} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        display="flex"
                                        alignItems="center"
                                        position="relative"
                                        xs={12}
                                        container
                                        item
                                        mb={2}
                                        sx={{
                                            background: '#fff',
                                            width: '100%',
                                        }}
                                    >
                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item container xs={2}>
                                                <SuiTypography variant="h6" color="secondary" fontWeight="bold" textAlign="left">
                                                    Goods
                                                </SuiTypography>
                                            </Grid>
                                            <Grid container item xs={9.7}>
                                                {state.selectedShipment.goods.map((x, index) =>
                                                    <GoodsRow
                                                        key={index}
                                                        index={index}
                                                        handleRowChange={handleGoodsRowChange}
                                                        handleRowChangeWithMaxLenght={handleGoodsRowChange}
                                                        removeGoodsLine={removeGoodsLine}
                                                        goods={state.selectedShipment.goods}
                                                        showDescription={true}
                                                        state={goodsState}
                                                        shipmentFormType={'admin'}
                                                    />)}
                                            </Grid>
                                        </Grid>

                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item container xs={2}></Grid>
                                            <Grid item xs={6}>
                                                <SuiButton variant="outlined" size="small" color="primary" onClick={addGoodsLine}>+ Cargo item row</SuiButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        container
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                        spacing={2}
                                    >
                                        <Grid item>
                                            <SuiButton onClick={handleBookingUpdate} variant="contained" color="secondary">
                                                Update
                                            </SuiButton>
                                        </Grid>
                                        <Grid item>
                                            <SuiButton onClick={handleClose} variant="contained" color="secondary">
                                                Close
                                            </SuiButton>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {tabValue === 1 && (
                                <>
                                    <Tracking state={state.selectedShipment.shipmentStatuses} trackingUrl={state.selectedShipment.trackingUrl} />
                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        container
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Grid item>
                                            <SuiButton onClick={handleClose} variant="contained" color="secondary">
                                                Close
                                            </SuiButton>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {tabValue === 2 && (
                                <>
                                    <Grid item container xs={12} spacing={2} mt={2}>
                                        <BillingInput
                                            state={state.selectedShipment}
                                            purchasePrice={purchasePrice}
                                            handleBasicInfoChange={handleBasicInfoChange}
                                            addPricingDetail={addPricingDetail}
                                            saveBillingDetails={saveBillingDetails}
                                            addAdditionalService={addAdditionalService}
                                            handleDeletePricingDetail={handleDeletePricingDetail}
                                            handleDeleteAdditionalService={handleDeleteAdditionalService}
                                        />
                                    </Grid>
                                    <Divider sx={{ mt: 2, mb: 2 }} />
                                    <Grid
                                        container
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Grid item xs={3} display='flex' justifyContent='center' alignItems='flex-end'>
                                            <SuiButton variant="contained" color="secondary" onClick={saveBillingDetails}>
                                                Save
                                            </SuiButton>
                                        </Grid>
                                        <Grid item>
                                            <SuiButton onClick={handleClose} variant="contained" color="secondary">
                                                Close
                                            </SuiButton>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </DialogContent>
                        <DialogActions></DialogActions>
                    </>
                }
            </Dialog>
        </React.Fragment>
    );
}





